import { Spinner } from '@fluentui/react-components';
import { SpinnerContainer } from './styles/LoadingSpinner.styled';

interface LoadingSpinnerProps {
  absolute?: boolean;
}

export const LoadingSpinner = ({ absolute }: LoadingSpinnerProps) => {
  return (
    <SpinnerContainer absolute={absolute}>
      <Spinner size="huge" />
    </SpinnerContainer>
  );
};
